import React from "react";
import { Input } from "reactstrap";
import { useTranslation } from "react-i18next";

// Menu Tavolo: tavoli In uso raggruppati per sala ("T5 · 4–6 posti") più "Nessun tavolo".
// `current` = tavoli già assegnati [{id,name}]: se non sono tra quelli in uso restano visibili.
const TableSelect = ({ groups, current = [], value, onChange, ...rest }) => {
  const { t } = useTranslation("bookings");
  const known = new Set(groups.flatMap((g) => g.tables.map((x) => x.id)));
  const extra = current.length > 1
    ? [{ id: value, name: current.map((x) => x.name).join(" + ") }]
    : current.filter((x) => !known.has(x.id));
  const seats = (x) => (x.seats_min === x.seats_max ? t("agenda.seatsOne", { n: x.seats_max }) : t("agenda.seats", { min: x.seats_min, max: x.seats_max }));
  return (
    <Input type="select" value={value || ""} onChange={(e) => onChange(e.target.value)} {...rest}>
      <option value="">{t("agenda.noTable")}</option>
      {extra.map((x) => <option key={`x${x.id}`} value={x.id}>{x.name}</option>)}
      {groups.map((g) => (
        <optgroup key={g.id} label={g.name}>
          {g.tables.map((x) => <option key={x.id} value={x.id}>{x.name} · {seats(x)}</option>)}
        </optgroup>
      ))}
    </Input>
  );
};

export default TableSelect;
